module.exports = __webpack_public_path__ + "static/media/vis4.114c4f9c.jpeg";